import {
  TEntityResponse,
  TEntityListResponse,
  TMetricTypeResBody,
  TMetricTypeSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TMetricsClient = {
  get(id: string): Promise<TEntityResponse<'metric-type', TMetricTypeResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'metric-type', TMetricTypeSummaryResBody> | undefined>;
};

function MetricsClient(apiClient: TAPIClient): TMetricsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'metric-type', TMetricTypeResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'metric-type', TMetricTypeResBody>>(`/metric-types/${id}`);

      if (data && data.type !== 'metric-type') {
        throw new Error('Invalid entity type received, expected: metric-type, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'metric-type', TMetricTypeSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'metric-type', TMetricTypeSummaryResBody>>(
        `/metric-types?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'metric-type') {
        throw new Error('Invalid entity type received, expected: metric-type, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TMetricsClient, MetricsClient };
